import { get } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

const { APIS } = API_ENDPOINTS;

export const fetchAllAccounts = () =>
  new Promise((resolve, reject) => {
    get(APIS.ACCOUNTS_V2)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchAssetsByAccount = accountID =>
  new Promise((resolve, reject) => {
    get(`${APIS.ASSETS}/${accountID}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
